import React from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { functional } from 'Mui/styles/color';
import AssignmentIcon from '@material-ui/icons/Assignment';
import usePromoSettingComponentStyle from 'hooks/usePromoSettingComponentStyle';
import { stylePropType } from 'utils/propTypes';

const ViewFormButton = ({ style, onClick = () => {} }) => {
    const componentStyle = usePromoSettingComponentStyle();
    return (
        <div css={[btnWrapperStyle, style]}>
            <div css={btnStyle(componentStyle?.buttonBgColor)} onClick={onClick}>
                <AssignmentIcon />
                {i18n.t('label.view_latest_reply')}
            </div>
        </div>
    );
};

export default ViewFormButton;

ViewFormButton.propTypes = {
    color: PropTypes.string,
    style: stylePropType,
    onClick: PropTypes.func
};

const btnWrapperStyle = css`
    display: flex;
    justify-content: center;
    padding: 8px;
`;

const btnStyle = color => css`
    display: inline-flex;
    align-items: center;
    color: ${color || functional.color};
    cursor: pointer;
    text-align: center;
    > svg {
        font-size: 24px;
        margin-right: 5px;
    }
`;
